import { ProductContent, ProductImage } from '@/components/catalogue/products/cards/ProductCard';
import { Card } from '@/components/sections/Card';
import { PriceBreakdown } from '@/pages/product/price/PriceHistoryModal';
import { Product } from '@/services/api/contracts/catalog/types';
import { FunctionComponent } from 'react';

interface PurchaseOrderCompleteedProductCardProps {
  product: Product;
  quantity: number;
  showDeviceFee?: boolean;
}

const PurchaseOrderCompleteedProductCard: FunctionComponent<PurchaseOrderCompleteedProductCardProps> = ({
  product,
  quantity,
  showDeviceFee
}) => {
  return (
    <Card className="flex flex-col items-stretch overflow-clip">
      <div className="flex border-b w-full relative">
        <ProductImage product={product} />
      </div>
      <ProductContent product={product} quantity={quantity}  />

      {product.price && (
        <div className="border-secondary-std group flex items-center justify-between gap-2 border-t bg-[#F3FCFE] px-4 py-3">
          <PriceBreakdown
            date={new Date(product.price.date)}
            percentages={[]}
            price={product.price.price}
            categoryId={product.category.id}
            manufacturerId={product.manufacturer.id}
            regionCode={product.region?.code}
            showDeviceFee={showDeviceFee}
          />
        </div>
      )}
    </Card>
  );
};

export default PurchaseOrderCompleteedProductCard;
